import { render, staticRenderFns } from "./MppAppMenu.vue?vue&type=template&id=cfe642a4&scoped=true"
import script from "./MppAppMenu.vue?vue&type=script&lang=js"
export * from "./MppAppMenu.vue?vue&type=script&lang=js"
import style0 from "./MppAppMenu.vue?vue&type=style&index=0&id=cfe642a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe642a4",
  null
  
)

export default component.exports